 <div *ngFor="let lastUpdated of lastUpdateds">
    <p>Last Modified By : {{lastUpdated.CreatedBy}}</p>
      <p>
        Modified Date: {{lastUpdated.CreatedDate}}
      </p>
</div> 
